// extracted by mini-css-extract-plugin
export default {"project":"_1d3rQ9NCmdAiLFey8bHDG_ height-100 width-100","annotationMode":"_3643YyGWGxm0MCbyq8Tt6r","handoffMode":"_3NxGqjwVK5_U5bWdk-Ktxd bg-snow"};